import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-teklif-olusturuldu-public',
  templateUrl: './teklif-olusturuldu-public.component.html',
  styleUrls: ['./teklif-olusturuldu-public.component.scss']
})
export class TeklifOlusturulduPublicComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
